import React, { useState } from 'react';

function Tooltip({ children, content, placement = 'bottom', delay = 200 }) {
  const [show, setShow] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleMouseEnter = () => {
    const id = setTimeout(() => setShow(true), delay);
    setTimeoutId(id);
  };

  const handleMouseLeave = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setShow(false);
  };

  const placementClasses = {
    top: 'bottom-full mb-2 left-1/2 transform -translate-x-1/2',
    bottom: 'top-full mt-2 left-1/2 transform -translate-x-1/2',
    left: 'right-full mr-2 top-1/2 transform -translate-y-1/2',
    right: 'left-full ml-2 top-1/2 transform -translate-y-1/2',
  };

  const arrowClasses = {
    top: 'top-full left-1/2 transform -translate-x-1/2 -mt-1 rotate-45',
    bottom: 'bottom-full left-1/2 transform -translate-x-1/2 -mb-1 rotate-45',
    left: 'left-full top-1/2 transform -translate-y-1/2 -ml-1 rotate-45',
    right: 'right-full top-1/2 transform -translate-y-1/2 -mr-1 rotate-45',
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>

      {show && (
        <div className={`absolute z-50 ${placementClasses[placement]}`}>
          <div className="px-3 py-2 bg-gray-900 border border-gray-700 rounded-lg shadow-xl text-white text-sm max-w-xs">
            {content}
            {/* Arrow */}
            <div className={`absolute w-2 h-2 bg-gray-900 border-r border-b border-gray-700 ${arrowClasses[placement]}`}></div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tooltip;
